import { Container, Row, Col, Modal, Button } from "react-bootstrap"
import { ArrowRightCircle } from 'react-bootstrap-icons'
import { useState } from 'react'
import Image from 'react-bootstrap/Image'
import headerImg from '../../assets/logos/TMLogo.png'
import modalImg from '../../assets/img/person-persenting-large-group-3.png'
import 'animate.css';

export const Banner = (homePageData) => {

    const [showJoinNow, setShowJoinNow] = useState(false)
    const handleCloseJoinNow = () => setShowJoinNow(false)
    const handleShowJoinNow = () => setShowJoinNow(true)
    // console.log(homePageData)

    return (
        <section className="banner" id="welcome">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={5} className="mb-60 pe-5" >
                        <div className="animate__animated animate__zoomIn">
                            <img src={headerImg} alt="Header Img" />
                            <h2 className="text-center mt-5">WHERE LEADERS ARE MADE</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} xl={7}>
                        <div className="animate__animated animate__fadeIn">
                            <h1 className="animate__animated animate__slideInUp">
                                {homePageData.homePageData.banner.slogan0?.visible && <span className="bold">{homePageData.homePageData.banner.slogan0.text}</span>}
                                <br />
                                {homePageData.homePageData.banner?.slogan1?.visible && <span>{homePageData.homePageData.banner.slogan1.text}</span>}
                            </h1>
                            <p><br /><br /></p>
                            <p className="border-top-bottom subtitle mb-30 mt-30 animate__animated animate__slideInUp">
                                When: {homePageData.homePageData.banner.when?.visible && <span className="bold">{homePageData.homePageData.banner.when.text}</span>}
                            </p>
                            {homePageData.homePageData.banner.where?.visible &&
                                <p>
                                    Where:&nbsp;
                                    <a
                                        href={homePageData.homePageData.banner.where.link}
                                        target='_blank'
                                        rel="noreferrer"
                                    >
                                        <span>{homePageData.homePageData.banner.where.text}</span>
                                    </a>

                                </p>
                            }
                            {homePageData.homePageData.banner.howToJoin?.visible &&
                                <>
                                    <button onClick={handleShowJoinNow} className="border-top-bottom subtitle mb-30 mt-30 animate__animated animate__slideInUp">How to join <ArrowRightCircle size={25} /></button>
                                    <Modal show={showJoinNow} onHide={handleCloseJoinNow} className='' data-bs-theme={'dark'} size="lg" style={{ top: '2%' }}>
                                        <Modal.Header closeButton >
                                            <Modal.Title>How to join?</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col xs={12} md={6} >
                                                    <Image src={modalImg} alt="A man presenting in a meeting" fluid />
                                                </Col>
                                                <Col>
                                                    <div dangerouslySetInnerHTML={{ __html: homePageData.homePageData.banner.howToJoin.text }}></div>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleCloseJoinNow}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </>
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </section >
    )
}
